export default "__VITE_ASSET__imU$VMY7__";